import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeoService } from 'cartoservice/static/cartoservice/src/classes';
import { empty, Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Attribute, Layer, Service } from '../classes';
import { API_URL } from '../config';

@Injectable()
export class LayerService {
  private layers: Layer[];

  constructor(private http: HttpClient) {}

  updateLayers(data: any): Promise<any> {
    this.walkLayersRecursive(data.groups as Layer[], (layer: Layer) => {
      layer.title = layer.name;
      layer.sublayers = layer.subLayers;
      layer.is_group = layer.isGroup;
      return true;
    });
    return this.http.patch(`${API_URL}/layertree/`, data, { responseType: 'text' }).toPromise();
  }

  getLayersForProject(projectName: string): Observable<Layer[] | {}> {
    return this.http.get<any>(`${API_URL}/layertree/?project__name=${projectName}`).pipe(
      map(data => {
        return this.getLayers(data);
      }),
      catchError(this.handleError)
    );
  }

  // запрашиваем атрибуты только для слоев Геоаналитики
  getAttributes(layer: Layer): Observable<Attribute[]> {
    // если слой редактируется, запрашиваем атрибуты слоя
    if (layer.resource_uri && layer.service instanceof Service && layer.service.resource_uri) {
      return this.http.get<any>(`${API_URL}/layertree/${layer.id}`).pipe(
        map(layerData => layerData.attributes.map((attribute: any) => new Attribute(attribute))),
        catchError(this.handleError)
      );
      // если это новый слой, запрашиваем атрибуты сервиса
    } else if ((layer.service as GeoService).internal) {
      return this.http.get<any>(`/cartoservice${API_URL}/${layer.service.type}/${layer.service.id}/`).pipe(
        map(serviceData => serviceData.attributes.map((attribute: any) => new Attribute(attribute))),
        catchError(this.handleError)
      );
    } else {
      return empty();
    }
  }

  private handleError(ex: any): any {
    const msg = 'Reguest error:' + ex;
    console.error(msg);
    return observableThrowError(msg);
  }

  private getLayers(data: any): Layer[] {
    this.layers = this.parseTree(data.groups, null);
    return this.layers;
  }

  private parseTree(objects: any[], parentLayer: Layer): Layer[] {
    return objects.map(object => {
      const layer = new Layer(
        Object.assign(object, {
          service: new Service({
            title: object.wms_title ? object.wms_title : object.service_title,
            time: object.time,
            resource_uri: object.content_object,
            id: object.object_id,
            editable: object.service.editable
          })
        })
      );
      if (parentLayer) {
        layer.parent = parentLayer;
      }
      if (object.sublayers.length) {
        layer.sublayers = this.parseTree(object.sublayers, layer);
      }
      layer.subLayers = layer.sublayers;
      layer.isGroup = layer.is_group;
      layer.name = layer.title;
      return layer;
    });
  }

  // walk layers until callback return false
  public walkLayersRecursive(layers: Layer[], callback: ((layer: Layer, layers: Layer[]) => boolean)) {
    for (const layer of layers) {
      if (callback(layer, layers)) {
        if (layer.subLayers && layer.subLayers[0]) {
          this.walkLayersRecursive(layer.subLayers, callback);
        }
      } else {
        return;
      }
    }
  }
}
